<template>
  <div>
    <div class="text-light" @click="toggleFilter">
      <slot />
    </div>
    <div class="relative">
      <div :class="openFilters ? 'filter-overlay' : ''" @click="toggleFilter" />
      <div class="filter-dropdown" v-if="openFilters" :class="classes">
        <div class="filter-title">
          {{ placeholder }}
        </div>

        <p class="filter-title">Start Date</p>
        <div class="form__item">
          <input
            placeholder="dd/mm/yyyy"
            class="date margin-right"
            type="date"
            id="date"
            v-model="filterList.date_from"
          />
          <span class="attention" v-if="$v.filterList.date_from.$error"
            >Please select a start date</span
          >
        </div>

        <p class="filter-title">End Date</p>
        <div>
          <input
            placeholder="dd/mm/yyyy"
            class="date margin-right"
            type="date"
            id="date"
            v-model="filterList.date_to"
          />
          <span class="attention" v-if="$v.filterList.date_to.$error"
            >Please select an end date</span
          >
        </div>

        <p class="filter-title">Nuban</p>
        <div>
          <input
            placeholder="899999999"
            class="date margin-right"
            type="number"
            id="date"
            v-model="filterList.vnuban"
          />
          <span class="attention" v-if="$v.filterList.vnuban.$error"
            >Please enter vnuban</span
          >
        </div>

        <div class="" v-if="exportType && exportType.length">
          <p class="filter-title my-3">Export Type</p>
          <div
            v-for="type in exportType"
            class="status-element"
            :key="type.id"
            @click="setExportType(type)"
          >
            <p v-if="type.id === filterList.export_type">
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle cx="8" cy="8" r="8" fill="#e00b5b" />
                <path
                  d="M11 6L6.875 10L5 8.18182"
                  stroke="white"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </p>
            <p v-else>
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle cx="8" cy="8" r="7.5" stroke="#979797" />
              </svg>
            </p>
            <p class="filter-title">
              {{ type.name }}
            </p>
          </div>
          <span class="attention" v-if="$v.filterList.export_type.$error"
            >Please select an export type</span
          >
        </div>

        <div class="button-group">
          <button
            class="btn woven-border-only woven-red bg-white"
            @click="clearFilter"
          >
            Reset Filter
          </button>
          <button class="btn woven-color" @click="getAccountStatement">
            <p>{{ loading ? "Loading..." : "Generate" }}</p>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
export default {
  props: ["placeholder", "classes", "noStatusText"],
  data() {
    return {
      filterList: { export_type: "" },
      exportType: [
        { id: "CSV", name: "CSV" },
        { id: "EXCEL", name: "Excel" },
      ],
      openFilters: null,
      loading: false,
    };
  },
  validations: {
    filterList: {
      date_from: {
        required,
      },
      date_to: {
        required,
      },
      vnuban: {
        required,
      },

      export_type: {
        required,
      },
    },
  },
  methods: {
    async getAccountStatement() {
      this.$v.filterList.$touch();
      if (this.$v.filterList.$invalid) {
        return;
      }
      this.loading = true;
      await this.$store.dispatch("generateAccountStatement", {
        ...this.filterList,
        merchant_id: this.$route.params.id,
      });
      this.loading = false;
      this.clearFilter();
    },

    clearFilter() {
      this.filterList = {};
      this.openFilters = false;
    },

    setExportType(type) {
      this.filterList.export_type = type.id;
    },

    toggleFilter() {
      this.openFilters = !this.openFilters;
    },
  },
};
</script>
<style lang="scss" scoped>
.relative {
  position: relative;
}

.filter-dropdown {
  background: #fff;
  padding: 20px;
  box-shadow: 0 0 3px rgba(0, 0, 0, 0.25);
  position: absolute;
  top: 30px;
  z-index: 100;
  left: 0 !important;
  min-width: 300px;

  .form__item {
    margin-bottom: 16px;
  }
}

.woven-color {
  background: #e00b5b;
  border-radius: 4px;
  color: #fff;
  font-size: 14px;
  height: 40px;

  svg {
    margin-right: 5px;
  }

  .btn--text {
    font-style: normal;
    font-weight: 500;
    color: #fff;
    width: 100%;
    text-align: center;
  }
}

.filter-dropdown {
  background: #fff;
  padding: 20px;
  box-shadow: 0 0 3px rgba(0, 0, 0, 0.25);
  position: absolute;
  top: 30px;
  z-index: 100;
  /*left: 145px;*/
  min-width: 300px;

  .form__item {
    margin-bottom: 16px;
  }
}

.button-group {
  display: flex;
  justify-content: space-between;
  padding-top: 20px;
  margin-top: 32px;
  border-top: 1px solid rgba(196, 196, 196, 0.5);

  p {
    width: 100%;
  }

  .btn {
    width: 100px;
    height: 40px;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 16px;
    padding: 10px;
    text-align: center;
  }
}

.date,
input,
.form__input {
  border: 0.5px solid rgba(97, 110, 124, 0.5);
  box-sizing: border-box;
  border-radius: 4px;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 16px;
  color: rgba(97, 110, 124, 0.8);
  padding: 12px 10px !important;
  width: 100%;
}

.form__item {
  border: none;
}

.status-element {
  display: flex;

  svg {
    margin-right: 10px;
    cursor: pointer;
  }
}

.text-light {
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
  color: #595959;

  span {
    color: #e00b5b;
    cursor: pointer;
  }
}

.filter-title {
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 14px;
  color: #9a9fa3;
  margin: 5px 0;
}

.filter-overlay {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  content: " ";
  z-index: 1;
}
</style>
